<template>
  <va-card :title="$t(`liveComponents.cards.title`)">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="row">
          <div class="flex md12">
            <ValidationProvider rules="max:60" name="Titulo" v-slot="{ errors }">
              <va-input
                v-model="title"
                :label="$t('liveComponents.forms.titleLabel')"
                :placeholder="$t('liveComponents.forms.titlePlaceholder')"
                :success="errors.length == 0 && title.length >= 0"
                :error="errors.length > 0"
                :error-messages="errors"
              />
            </ValidationProvider>
            <ValidationProvider rules="max:42" name="Sub Titulo" v-slot="{ errors }">
              <va-input
                v-model="subtitle"
                :label="$t('liveComponents.forms.subtitleLabel')"
                :placeholder="$t('liveComponents.forms.subtitlePlaceholder')"
                :success="errors.length == 0 && subtitle.length >= 0"
                :error="errors.length > 0"
                :error-messages="errors"
              />
            </ValidationProvider>
            <ValidationProvider rules="max:13" name="Hashtag" v-slot="{ errors }">
              <va-input
                v-model="hashtag"
                :label="$t('liveComponents.forms.hashtagLabel')"
                :placeholder="$t('liveComponents.forms.hashtagPlaceholder')"
                :success="errors.length == 0 && hashtag.length >= 0"
                :error="errors.length > 0"
                :error-messages="errors"
              />
            </ValidationProvider>
            <ValidationProvider rules="max:13" name="Temporada" v-slot="{ errors }">
              <va-input
                v-model="temp"
                :label="$t('liveComponents.forms.temporadaLabel')"
                :placeholder="$t('liveComponents.forms.temporadaPlaceholder')"
                :success="errors.length == 0 && temp >= 0"
                :error="errors.length > 0"
                :error-messages="errors"
              />
            </ValidationProvider>
            <div class="form-group">
              <va-select
                :label="$t('liveComponents.forms.championshipLabel')"
                v-model="campeonatos"
                textBy="name"
                keyBy='id'
                no-clear
                searchable
                :placeholder="$t('liveComponents.forms.championshipPlaceholder')"
                :noOptionsText="$t('liveComponents.forms.championshipNoOption')"
                maxHeight='200px'
                :options="championships.length > 0 ? championships : []"
              />
            </div>
            <div class="d-flex mt-3">
              <va-button
                type="submit"
                :disabled="buttonSubmitDisabled"
                color="success"
                class="my-0">
                {{ textSubmit }}
              </va-button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </va-card>
</template>
<script>
import gql from 'graphql-tag'
export default {
  name: 'LiveComponents',
  data () {
    return {
      title_id: 0,
      title: '',
      subtitle_id: 0,
      subtitle: '',
      hashtag_id: 0,
      hashtag: '',
      temporada_id: 0,
      temporada: '',
      campeonato_id: 0,
      campeonato: '',
      campeonatos: '',
      championships: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  apollo: {
    settings: {
      query: gql`
      query MyQuery {
        settings(where:{key:{_in: [
            "Titulo_Live",
            "Sub_Titulo_Live",
            "Hashtag_Live",
            "Temporada_Live",
            "Campeonato_Live"
          ]}}){
          id
          key
          value
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.settings.length > 0) {
            data.settings.forEach((item) => {
              if (item.key.toLowerCase().includes('sub')) {
                this.subtitle_id = item.id
                this.subtitle = item.value
              } else if (item.key.toLowerCase().includes('titulo')) {
                this.title_id = item.id
                this.title = item.value
              } else if (item.key.toLowerCase().includes('hashtag')) {
                this.hashtag_id = item.id
                this.hashtag = item.value
              } else if (item.key.toLowerCase().includes('temporada')) {
                this.temporada_id = item.id
                this.temporada = item.value
              } else if (item.key.toLowerCase().includes('campeonato')) {
                this.campeonato_id = item.id
                this.campeonato = item.value
              }
            })
          }
        }
      },
    },
    championships: {
      query: gql`
      query MyQuery{
        championships: championship(where: {is_classification: {_eq: true}}) {
          id: id_api
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.championships.length > 0 && this.campeonatos === '') {
            this.campeonatos = Object.assign({}, data.championships[0])
          }
        }
      },
    },
  },
  computed: {
    temp: {
      get () {
        return this.temporada
      },
      set (value) {
        if (value >= 0) {
          this.temporada = value
        }
      },
    },
  },
  watch: {
    campeonatos (value) {
      if (value !== '') {
        this.campeonato = value.id
      }
    },
  },
  methods: {
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      this.$apollo
        .mutate({
          mutation: gql`
          mutation MyMutation(
            $id1: Int!, $value1: String!,
            $id2: Int!, $value2: String!,
            $id3: Int!, $value3: String!,
            $id4: Int!, $value4: String!,
            $id5: Int!, $value5: String!
          ) {
            up1: update_settings_by_pk(pk_columns: {id: $id1}, _set: {value: $value1}) {
              id
            }
            up2: update_settings_by_pk(pk_columns: {id: $id2}, _set: {value: $value2}) {
              id
            }
            up3: update_settings_by_pk(pk_columns: {id: $id3}, _set: {value: $value3}) {
              id
            }
            up4: update_settings_by_pk(pk_columns: {id: $id4}, _set: {value: $value4}) {
              id
            }
            up5: update_settings_by_pk(pk_columns: {id: $id5}, _set: {value: $value5}) {
              id
            }
          }
          `,
          variables: {
            id1: this.title_id,
            value1: this.title,
            id2: this.subtitle_id,
            value2: this.subtitle,
            id3: this.hashtag_id,
            value3: this.hashtag,
            id4: this.temporada_id,
            value4: this.temporada,
            id5: this.campeonato_id,
            value5: String(this.campeonato),
          },
        })
        .then(data => {
          this.buttonSubmitDisabled = false
          this.textSubmit = this.$t('forms.submit')
          this.showToast(
            this.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.buttonSubmitDisabled = false
          this.textSubmit = this.$t('forms.submit')
          this.showToast(
            this.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style>

</style>
